import { Recipe, RecipeSummary } from 'types';

const getCookingTime = (recipe: Recipe | RecipeSummary | undefined, numPeople: number) => {
  const cookingTime =
    recipe?.cookingTime.find(time => time.numPeople === numPeople) || recipe?.cookingTime[0];
  return cookingTime?.duration;
};

export default getCookingTime;
